var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPauseAtTask = function SvgPauseAtTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.083 17.328h21.883M11.213 15.212l.99-.024 6.666-.156 1.124-.027c.704-.144 4.176-2.507-3.933-2.5-2.784-1.665-4.174-3.86-6.014-5.882L8.1 7.02l3.07 5.41c-4.827.094-5.262-1.04-6.242-2.77l-1.886.154c1.973 2.026 1.512 4.767 8.172 5.397z"
  })));
};
export default SvgPauseAtTask;